import StudentSignupBlock from './StudentSignupBlock';
import { StudentSignupBlockProps, StudentSignupBlockValueProps } from './types';

export type { StudentSignupBlockProps, StudentSignupBlockValueProps };
export default StudentSignupBlock;
